import {
  LayoutDashboard, CalendarDays, Wrench, Package, Receipt, ShoppingCart, Users, BarChart3,
  Sparkles, CalendarCog, Shield, Settings, MessageSquare, LifeBuoy, Building2, CreditCard, ScrollText, UserCog,
} from "lucide-react";
import { FEATURES } from "@/types";

// Grouped navigation. Business modules carry a `flag` (feature flag). Items are shown
// when the user has `perm`; when the flag is off they render disabled. `built` marks
// pages that actually exist in this phase.
export const companySections = [
  {
    title: "Översikt", tKey: "overview",
    items: [
      { label: "Dashboard", to: "/dashboard", tKey: "dashboard", icon: LayoutDashboard, perm: "dashboard.view", end: true, built: true },
      { label: "Rapporter", to: "/dashboard/reports", tKey: "reports", icon: BarChart3, perm: "reports.view", flag: FEATURES.REPORTS },
    ],
  },
  {
    title: "Arbete", tKey: "work",
    items: [
      { label: "Bokningar", to: "/dashboard/bookings", tKey: "bookings", icon: CalendarDays, perm: "bookings.read", flag: FEATURES.BOOKINGS, built: true },
      { label: "Ärenden", to: "/dashboard/workorders", tKey: "workorders", icon: Wrench, perm: "workorders.read", flag: FEATURES.WORKORDERS, built: true },
      { label: "Lager", to: "/dashboard/inventory", tKey: "inventory", icon: Package, perm: "inventory.read", flag: FEATURES.INVENTORY, built: true },
      { label: "Fakturor", to: "/dashboard/invoices", tKey: "invoices", icon: Receipt, perm: "invoices.read", flag: FEATURES.INVOICING, built: true },
    ],
  },
  {
    title: "Kunder", tKey: "customers",
    items: [
      { label: "Kunder", to: "/dashboard/customers", tKey: "customersItem", icon: Users, perm: "customers.read", flag: FEATURES.CRM, built: true },
      { label: "Kommunikation", to: "/dashboard/communication", tKey: "communication", icon: MessageSquare, perm: "settings.manage", built: true },
    ],
  },
  {
    title: "Katalog", tKey: "catalog",
    items: [
      { label: "Tjänster & öppettider", to: "/dashboard/booking-settings", tKey: "bookingSettings", icon: CalendarCog, perm: "bookings.manage", flag: FEATURES.BOOKINGS, built: true },
      { label: "Webbshop", to: "/dashboard/webshop", tKey: "webshop", icon: ShoppingCart, perm: "webshop.manage", flag: FEATURES.WEBSHOP },
      { label: "AI", to: "/dashboard/ai", tKey: "ai", icon: Sparkles, perm: "dashboard.view", flag: FEATURES.AI },
    ],
  },
  {
    title: "System", tKey: "system",
    items: [
      { label: "Användare", to: "/dashboard/users", tKey: "users", icon: UserCog, perm: "users.read", built: true },
      { label: "Roller", to: "/dashboard/roles", tKey: "roles", icon: Shield, perm: "roles.read", built: true },
      { label: "Inställningar", to: "/dashboard/settings", tKey: "settings", icon: Settings, perm: "settings.manage", built: true },
      { label: "Abonnemang", to: "/dashboard/billing", tKey: "billing", icon: CreditCard, perm: "settings.manage", built: true },
      { label: "Support", to: "/dashboard/support", tKey: "support", icon: LifeBuoy, perm: "dashboard.view" },
    ],
  },
];

export const adminSections = [
  {
    title: "Plattform", tKey: "platform",
    items: [
      { label: "Dashboard", to: "/admin", tKey: "dashboard", icon: LayoutDashboard, end: true, built: true },
      { label: "Företag", to: "/admin/tenants", tKey: "tenants", icon: Building2, built: true },
      { label: "Abonnemang", to: "/admin/plans", tKey: "plans", icon: CreditCard },
      { label: "Systemloggar", to: "/admin/logs", tKey: "logs", icon: ScrollText },
      { label: "Inställningar", to: "/admin/settings", tKey: "settings", icon: Settings },
    ],
  },
];
